import { render, staticRenderFns } from "./certMsg.vue?vue&type=template&id=23d8fc0d&scoped=true&"
import script from "./certMsg.vue?vue&type=script&lang=js&"
export * from "./certMsg.vue?vue&type=script&lang=js&"
import style0 from "./certMsg.vue?vue&type=style&index=0&id=23d8fc0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d8fc0d",
  null
  
)

export default component.exports